export function AccountInfo (coupon = '', accountType = '') {
  return {
    coupon,
    accountType
  }
}
